"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var styles = function styles(theme) {
  return "\n  &.vds-tooltip {\n    background-color: ".concat(theme && theme.vds && theme.vds.tooltipBackground ? theme.vds.tooltipBackground : "#fff", ";\n    border: 1px solid ").concat(theme && theme.vds && theme.vds.tooltipOutline ? theme.vds.tooltipOutline : "#d7d7de", ";\n    display: none;\n    max-width: 20rem;\n    position: absolute;\n    z-index: 299;\n  }\n\n  & .vds-tooltip.vds-state--show {\n    display: block;\n  }\n\n  & .vds-tooltip-content {\n    display: block;\n    padding: ").concat(theme && theme.vds && theme.vds.tooltipPadding ? theme.vds.tooltipPadding : ".25rem", ";\n  }\n\n  & .vds-tooltip-text {\n    color: ").concat(theme && theme.vds && theme.vds.tooltipText ? theme.vds.tooltipText : "#222", ";\n    display: block;\n    font-size: .6875rem;\n    line-height: 1.4em;\n    text-align: center;\n  }\n");
};

var _default = styles;
exports.default = _default;